/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Tut_Part_LabelInputs */

const en_tut_part_label = /** @type {(inputs: Tut_Part_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Part ${i?.n}`)
};

const id_tut_part_label = /** @type {(inputs: Tut_Part_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bagian ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Part {n}" |
*
* @param {Tut_Part_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_part_label = /** @type {((inputs: Tut_Part_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Part_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_part_label(inputs)
	return en_tut_part_label(inputs)
});